import React, { useState, useEffect } from "react";
import {
  Row,
  Card,
  CardBody,
  Input,
  Button,
  Form,
  Modal,
  Table,
  ModalBody,
  ModalFooter,
  InputGroup,
  InputGroupAddon,
  CardHeader,
  CardFooter,
} from "reactstrap";
import Pagination from "../../../containers/pages/Pagination";
import { Colxx } from "../../../components/common/CustomBootstrap";
import {
  updateBenfitsToAccountService,
  addAccountBenefits,
  getAccountService,
  deletebenefitsService,
  getAccountsBenefits
} from "../../../services/AccountService";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useHistory } from "react-router-dom";
import { isNullOrEmpty } from "../../../config/ENV";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";

toast.configure();

const AccountBenefits = () => {
  const [modalRight, setModalRight] = useState(false);
  const [search, setSearch] = useState("");
  const history = useHistory();
  const [account, setAccount] = useState({
    name: "",
    email: "",
    phoneNumber: "",
  });
  const [name, setname] = useState();
  const [cobra, setcobra] = useState(false);
  const [disability, setdisability] = useState(false);
  const [medicalLeave, setmedicalLeave] = useState(false);
  const [minimumWage, setminimumWage] = useState(false);
  const [overtime, setovertime] = useState(false);
  const [unEmploymentBenefit, setunEmploymentBenefit] = useState(false);
  const [workerCompensation, setworkerCompensation] = useState(false);
  const [bonusPay, setbonusPay] = useState(false);
  const [compensation401k, setcompensation401k] = useState(false);
  const [stockOption, setstockOption] = useState(false);
  const [health, sethealth] = useState(false);
  const [dental, setdental] = useState(false);
  const [vision, setvision] = useState(false);
  const [lifeInsurance, setlifeInsurance] = useState(false);
  const [paidHoliday, setpaidHoliday] = useState(false);
  const [paidSickTime, setpaidSickTime] = useState(false);
  const [paidVacation, setpaidVacation] = useState(false);
  const [flexibleHour, setflexibleHour] = useState(false);
  const [parentalLeave, setparentalLeave] = useState(false);
  const [empDiscount, setempDiscount] = useState(false);
  const [profDeveAssistance, setprofDeveAssistance] = useState(false);
  const [tuition, settuition] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPage, setTotalPage] = useState(1);
  let [itemsPerPage, setItemsPerPage] = useState();
  const [accountbenefitid, setAccountBenefitsid] = useState("");
  const [accountbenefitname, setaccountbenefitname] = useState("");
  const [selectedPageSize, setSelectedPageSize] = useState(2);

  const startIndex = (currentPage - 1) * selectedPageSize;
  const endIndex = currentPage * selectedPageSize;
  const [accountbenefits, setAccountBenefits] = useState([]);

  const [addMoreBenefitsList, setAddMoreBenefitsList] = useState([]);
  const [additionalBenefit, setAdditionalBenefit] = useState("");

  const [selectedBenefitId, setSelectedBenefitId] = useState("");
  const [size, setSize] = useState();
  const [modalDelete, setModalDelete] = useState(false);
  const [benefitError, setBenefitError] = useState("");
  const [addBenefitFlag, setAddBenefitFlag] = useState(false);
  const {id} = useParams()
  var accountId = id
  const Back = () => {
    history.push("/accounts");
  };
  const cancel = () => {
    setModalRight(false);
    clearDetails();
  };

  let count = 0;

  useEffect(() => {
    let accountId = id;
    if (accountId !== "") {
      getAccountDetails(accountId);
      // getAccountBenefitDetails(accountId);
    }
  }, [count]);

  function handleSearch(e, key) {
    setSearch(e.target.value);
  }

  function handleItemsPerChange(e, key) {
    setItemsPerPage(e.target.value);
    setCurrentPage(1);
  }

  function onChangePage(e) {
    setCurrentPage(e);
  }

  function handleChange(e) {
    setAdditionalBenefit(e.target.value);
    setAddBenefitFlag(false);
  }

  function handleAdd() {
    if (isNullOrEmpty(additionalBenefit)) {
      setBenefitError("Please enter additional benefits");
      setAddBenefitFlag(true);
      return;
    }
    addMoreBenefitsList.push(additionalBenefit);
    setAddMoreBenefitsList(addMoreBenefitsList);
    setAdditionalBenefit("");
  }

  function handleRemove(item, index) {
    let benefitsList = [...addMoreBenefitsList];
    if (benefitsList.length > 0) {
      for (let i = 0; i < benefitsList.length; i++) {
        if (i == index) {
          benefitsList.splice(i, 1);
        }
      }
      setAddMoreBenefitsList(benefitsList);
    }
  }

  useEffect(() => {
    getbenefits(currentPage);
  }, [itemsPerPage, currentPage]);

  const getbenefits = (currentpage) => {
    setCurrentPage(currentpage);

    if (itemsPerPage === undefined || itemsPerPage === "") {
      itemsPerPage = 25;
    }
    getAccountsBenefits(accountId,search, itemsPerPage, currentpage).then((response) => {
      let size = response.data.size;
      setSize(size);
      try {
        var accountBenefits = response.data.accountBenefits;
        setAccountBenefits(accountBenefits);
        const pages = Math.floor(size / itemsPerPage);
        if (Math.round(size % itemsPerPage) > 0) {
          const totalPages = pages + 1;
          setTotalPage(totalPages);
        } else {
          const totalPages = pages;
          setTotalPage(totalPages);
        }
      } catch (err) {
        console.log("address" + JSON.stringify(err.message));
      }
    });
  };

  const openModel = (benefit) => {
    setSelectedBenefitId(benefit.id);

    setModalRight(true);
    setname(benefit.name);
    setcobra(benefit.cobra);
    setdisability(benefit.disability);
    setmedicalLeave(benefit.medicalLeave);
    setminimumWage(benefit.minimumWage);
    setovertime(benefit.overtime);
    setunEmploymentBenefit(benefit.unEmploymentBenefit);
    setworkerCompensation(benefit.workerCompensation);
    setbonusPay(benefit.bonusPay);
    setcompensation401k(benefit.compensation401k);
    setstockOption(benefit.stockOption);
    sethealth(benefit.health);
    setdental(benefit.dental);
    setvision(benefit.vision);
    setlifeInsurance(benefit.lifeInsurance);
    setpaidHoliday(benefit.paidHoliday);
    setpaidSickTime(benefit.paidSickTime);
    setpaidVacation(benefit.paidVacation);
    setflexibleHour(benefit.flexibleHour);
    setparentalLeave(benefit.parentalLeave);
    setempDiscount(benefit.empDiscount);
    setprofDeveAssistance(benefit.profDeveAssistance);
    settuition(benefit.tuition);
    if (benefit.perks) {
      setAddMoreBenefitsList(benefit.perks);
    }
  };

  const submitBenefits = () => {
    let benfitsobject = {
      name: name,
      cobra: cobra,
      disability: disability,
      medicalLeave: medicalLeave,
      minimumWage: minimumWage,
      overtime: overtime,
      unEmploymentBenefit: unEmploymentBenefit,
      workerCompensation: workerCompensation,
      bonusPay: bonusPay,
      compensation401k: compensation401k,
      stockOption: stockOption,
      health: health,
      dental: dental,
      vision: vision,
      lifeInsurance: lifeInsurance,
      paidHoliday: paidHoliday,
      paidSickTime: paidSickTime,
      paidVacation: paidVacation,
      flexibleHour: flexibleHour,
      parentalLeave: parentalLeave,
      empDiscount: empDiscount,
      profDeveAssistance: profDeveAssistance,
      tuition: tuition,
      perks: addMoreBenefitsList,
    };
    if (benfitsobject.name === "") {
      toast.error("Please enter name");
      return;
    }

    if (selectedBenefitId === "") {
      addAccountBenefits(benfitsobject, accountId).then((response) => {
        try {
          if (response.data != null) {
            toast.success("Account benefits added successfully");
            setModalRight(false);
            getbenefits(currentPage);
            clearDetails();
          }
        } catch (err) {
          console.log("message" + JSON.stringify(err.message));
        }
      });
    } else {
      updateBenfitsToAccountService(
        benfitsobject,
        accountId,
        selectedBenefitId
      ).then((response) => {
        try {
          if (response.data !== null) {
            toast.success("Account benefits updated successfully");
            setSelectedBenefitId("");
            setModalRight(false);
            getbenefits(currentPage);
            clearDetails();
          }
        } catch (err) {
          console.log("message" + JSON.stringify(err.message));
        }
      });
    }
  };

  const handledeleteaccountbenefit = (deleteId, name) => {
    setAccountBenefitsid(deleteId);
    setaccountbenefitname(name);
    setModalDelete(deleteId);
  };

  const deletebenefits = () => {
    deletebenefitsService(accountId, accountbenefitid).then((response) => {
      try {
        if (response.data != null || response.data != undefined) {
          toast.success("Benefits deleted successfully");
          getbenefits(currentPage);
        }       
      } catch (err) {
        console.log("message" + JSON.stringify(err.message));
      }
      setModalDelete(false);
    });
  };

  const getAccountDetails = (accountId) => {
    getAccountService(accountId).then((response) => {
      try {
        var AccountDetails = response.data;
        if (AccountDetails !== null) {
          if (AccountDetails.name !== null || AccountDetails.name !== "") {
            setAccount((prevState) => ({
              ...prevState,
              name: AccountDetails.name,
            }));
          }
          if (AccountDetails.email !== null || AccountDetails.email !== "") {
            setAccount((prevState) => ({
              ...prevState,
              email: AccountDetails.email,
            }));
          }
          if (
            AccountDetails.phoneNumber !== null ||
            AccountDetails.phoneNumber !== ""
          ) {
            setAccount((prevState) => ({
              ...prevState,
              phoneNumber: AccountDetails.phoneNumber,
            }));
          }
        }
      } catch (err) {
        console.log("message" + JSON.stringify(err.message));
      }
    });
  };

  const clearDetails = () => {
    setSelectedBenefitId("");
    setname("");
    setcobra(false);
    setdisability(false);
    setmedicalLeave(false);
    setminimumWage(false);
    setovertime(false);
    setunEmploymentBenefit(false);
    setworkerCompensation(false);
    setbonusPay(false);
    setcompensation401k(false);
    setstockOption(false);
    sethealth(false);
    setdental(false);
    setvision(false);
    setlifeInsurance(false);
    setpaidHoliday(false);
    setpaidSickTime(false);
    setpaidVacation(false);
    setflexibleHour(false);
    setparentalLeave(false);
    setempDiscount(false);
    setprofDeveAssistance(false);
    settuition(false);
    setAddMoreBenefitsList([]);
    setAdditionalBenefit("");
  };

  const openBenefitsDetails = () => {
    setModalRight(true);
    clearDetails();
  };

  const getSerialNumber = (index) => {
    if (itemsPerPage === undefined || itemsPerPage === "") {
      itemsPerPage = 25;
    }
    return (currentPage - 1) * itemsPerPage + index + 1;
  };

  return (
    <>
      <Row>
        <Colxx xxs="12">
          <Card className="mt-2">
            <CardHeader>
              <div className="row">
                <Colxx sm={10} style={{ padding: 0 }}>
                  <div className="col">
                    <div className=" ml-3 ">
                      <h3 className="mt-2">
                        <b>{account.name}</b> | Benefits Packages
                      </h3>
                    </div>
                  </div>
                </Colxx>

                <Colxx sm={2}>
                  <div className="btn-group float-right">
                    <Button color="primary" outline size="sm" onClick={Back}>
                      Back
                    </Button>

                    <Button
                      color="primary"
                      outline
                      size="sm"
                      onClick={openBenefitsDetails}
                    >
                      Add
                    </Button>
                  </div>
                </Colxx>
              </div>
            </CardHeader>
            <CardBody>
              <div>
                {
                  <Row>
                    <Colxx>
                      <div className="row">
                        <Colxx>
                          <Row className="mb-3">
                            <Colxx sm={4}>
                              <InputGroup>
                                <Input
                                  type=""
                                  name=""
                                  placeholder="Search"
                                  onChange={handleSearch}
                                  value={search}
                                  className="form-control"
                                ></Input>
                                <InputGroupAddon addonType="append">
                                  <Button
                                    outline
                                    color="primary"
                                    onClick={(e) => getbenefits(1)}
                                  >
                                    Search
                                  </Button>
                                </InputGroupAddon>
                              </InputGroup>
                            </Colxx>

                            <Colxx sm={4} className="addbenefit_table ">
                              <Input
                                type="select"
                                value={itemsPerPage}
                                onChange={handleItemsPerChange}
                              >
                                <option value={""}>Items Per Page</option>
                                <option value={"10"}>10</option>
                                <option value={"25"}>25</option>
                                <option value={"50"}>50</option>
                                <option value={"100"}>100</option>
                              </Input>
                            </Colxx>
                          </Row>
                        </Colxx>
                      </div>

                      <Modal
                        scrollable={true}
                        isOpen={Boolean(modalRight)}
                        toggle={() => setModalRight(!modalRight)}
                        wrapClassName="modal-right"
                        className="benefits-model-width"
                      >
                        <ModalBody>
                          <div className="Container-box">
                            <div className="row">
                              <div className="col-sm-12">
                                <div className="barmenu_content barmenu_content_active">
                                  <div className="addexperience right">
                                    <h1>
                                      <b>
                                        {selectedBenefitId === ""
                                          ? "Add a new benefits package"
                                          : "Update existing benefits package"}
                                      </b>*
                                      {/* <span className="required-star"></span> */}
                                    </h1>
                                    <Form>
                                      <div>
                                        <Input
                                         className="t-rounded-lg"
                                          placeholder={"Name of the package"}
                                          data-testid="accountbenefit-name"
                                          value={name}
                                          onChange={(e) =>
                                            setname(e.target.value)
                                          }
                                          type="text"
                                        />
                                      </div>
                                      <Colxx sm={12}>
                                        <h5 className="benefit_types">
                                          Mandated
                                        </h5>
                                      </Colxx>
                                      <Colxx sm={12}>
                                        <div className="row form-group">
                                          <div className="col-sm-4">
                                            <div className="custom-checkbox custom-control custom-control-inline">
                                              <label>
                                                <input
                                                  type="checkbox"
                                                  data-testid="account-cobra"
                                                  className="custom-control-input"
                                                  name="cobra"
                                                  checked={cobra}
                                                  onChange={(e) =>
                                                    setcobra(e.target.checked)
                                                  }
                                                />
                                                <div className="custom-control-label">
                                                  COBRA
                                                </div>
                                              </label>
                                            </div>
                                          </div>
                                          <div className="col-sm-4">
                                            <div className="custom-checkbox custom-control custom-control-inline">
                                              <label>
                                                <input
                                                  type="checkbox"
                                                  checked={disability}
                                                  onChange={(e) =>
                                                    setdisability(
                                                      e.target.checked
                                                    )
                                                  }
                                                  data-testid="account-disability"
                                                  className="custom-control-input"
                                                />
                                                <div className="custom-control-label">
                                                  Disability
                                                </div>
                                              </label>
                                            </div>
                                          </div>

                                          <div className="col-sm-4">
                                            <div className="custom-checkbox custom-control custom-control-inline">
                                              <label>
                                                <input
                                                  checked={minimumWage}
                                                  onChange={(e) =>
                                                    setminimumWage(
                                                      e.target.checked
                                                    )
                                                  }
                                                  type="checkbox"
                                                  data-testid="account-minimumWage"
                                                  className="custom-control-input"
                                                />
                                                <div className="custom-control-label">
                                                  Minimum Wage
                                                </div>
                                              </label>
                                            </div>
                                          </div>
                                          <div className="col-sm-4">
                                            <div className="custom-checkbox custom-control custom-control-inline">
                                              <label>
                                                <input
                                                  checked={overtime}
                                                  onChange={(e) =>
                                                    setovertime(
                                                      e.target.checked
                                                    )
                                                  }
                                                  type="checkbox"
                                                  data-testid="account-overtime"
                                                  className="custom-control-input"
                                                />
                                                <div className="custom-control-label">
                                                  Overtime
                                                </div>
                                              </label>
                                            </div>
                                          </div>
                                          <div className="col-sm-4">
                                            <div className="custom-checkbox custom-control custom-control-inline">
                                              <label>
                                                <input
                                                  checked={unEmploymentBenefit}
                                                  onChange={(e) =>
                                                    setunEmploymentBenefit(
                                                      e.target.checked
                                                    )
                                                  }
                                                  type="checkbox"
                                                  data-testid="account-unEmploymentBenefit"
                                                  className="custom-control-input"
                                                />
                                                <div className="custom-control-label">
                                                  Unemployment Benefits
                                                </div>
                                              </label>
                                            </div>
                                          </div>
                                          <div className="col-sm-4">
                                            <div className="custom-checkbox custom-control custom-control-inline">
                                              <label>
                                                <input
                                                  checked={workerCompensation}
                                                  onChange={(e) =>
                                                    setworkerCompensation(
                                                      e.target.checked
                                                    )
                                                  }
                                                  type="checkbox"
                                                  data-testid="account-workerCompensation"
                                                  className="custom-control-input"
                                                />
                                                <div className="custom-control-label">
                                                  Workers Compensation
                                                </div>
                                              </label>
                                            </div>
                                          </div>
                                          <div className="col-sm-7">
                                            <div className="custom-checkbox custom-control custom-control-inline">
                                              <label>
                                                <input
                                                  type="checkbox"
                                                  checked={medicalLeave}
                                                  onChange={(e) =>
                                                    setmedicalLeave(
                                                      e.target.checked
                                                    )
                                                  }
                                                  data-testid="account-medicalLeave"
                                                  className="custom-control-input"
                                                />
                                                <div className="custom-control-label">
                                                  Family and Medical Leave Act
                                                </div>
                                              </label>
                                            </div>
                                          </div>
                                        </div>
                                      </Colxx>
                                      <Colxx
                                        sm={12}
                                        className="border-top pt-1"
                                      >
                                        <h5 className="benefit_types">
                                          Compensation
                                        </h5>
                                      </Colxx>
                                      <Colxx sm={12}>
                                        <div className="row form-group">
                                          <div className="col-sm-4">
                                            <div className="custom-checkbox custom-control custom-control-inline">
                                              <label>
                                                <input
                                                  checked={bonusPay}
                                                  onChange={(e) =>
                                                    setbonusPay(
                                                      e.target.checked
                                                    )
                                                  }
                                                  type="checkbox"
                                                  data-testid="account-bonusPay"
                                                  className="custom-control-input"
                                                />
                                                <div className="custom-control-label row-sm-4">
                                                  Bonus Pay
                                                </div>
                                              </label>
                                            </div>
                                          </div>
                                          <div className="col-sm-4">
                                            <div className="custom-checkbox custom-control custom-control-inline">
                                              <label>
                                                <input
                                                  checked={compensation401k}
                                                  onChange={(e) =>
                                                    setcompensation401k(
                                                      e.target.checked
                                                    )
                                                  }
                                                  type="checkbox"
                                                  data-testid="account-compensation401k"
                                                  className="custom-control-input"
                                                />
                                                <div className="custom-control-label">
                                                  401k
                                                </div>
                                              </label>
                                            </div>
                                          </div>
                                          <div className="col-sm-4">
                                            <div className="custom-checkbox custom-control custom-control-inline">
                                              <label>
                                                <input
                                                  checked={stockOption}
                                                  onChange={(e) =>
                                                    setstockOption(
                                                      e.target.checked
                                                    )
                                                  }
                                                  type="checkbox"
                                                  data-testid="account-stockOption"
                                                  className="custom-control-input"
                                                />
                                                <div className="custom-control-label">
                                                  Stock options
                                                </div>
                                              </label>
                                            </div>
                                          </div>
                                        </div>
                                      </Colxx>
                                      <Colxx
                                        sm={12}
                                        className="border-top pt-1"
                                      >
                                        <h5 className="benefit_types">
                                          Insurance
                                        </h5>
                                      </Colxx>
                                      <Colxx sm={12}>
                                        <div className="row form-group">
                                          <div className="col-sm-4">
                                            <div className="custom-checkbox custom-control custom-control-inline">
                                              <label>
                                                <input
                                                  checked={health}
                                                  onChange={(e) =>
                                                    sethealth(e.target.checked)
                                                  }
                                                  type="checkbox"
                                                  data-testid="account-health"
                                                  className="custom-control-input"
                                                />
                                                <div className="custom-control-label">
                                                  Health
                                                </div>
                                              </label>
                                            </div>
                                          </div>
                                          <div className="col-sm-4">
                                            <div className="custom-checkbox custom-control custom-control-inline">
                                              <label>
                                                <input
                                                  checked={dental}
                                                  onChange={(e) =>
                                                    setdental(e.target.checked)
                                                  }
                                                  type="checkbox"
                                                  data-testid="account-dental"
                                                  className="custom-control-input"
                                                />
                                                <div className="custom-control-label">
                                                  Dental
                                                </div>
                                              </label>
                                            </div>
                                          </div>
                                          <div className="col-sm-4">
                                            <div className="custom-checkbox custom-control custom-control-inline">
                                              <label>
                                                <input
                                                  checked={vision}
                                                  onChange={(e) =>
                                                    setvision(e.target.checked)
                                                  }
                                                  type="checkbox"
                                                  data-testid="account-vision"
                                                  className="custom-control-input"
                                                />
                                                <div className="custom-control-label">
                                                  Vision
                                                </div>
                                              </label>
                                            </div>
                                          </div>
                                          <div className="col-sm-4">
                                            <div className="custom-checkbox custom-control custom-control-inline">
                                              <label>
                                                <input
                                                  checked={lifeInsurance}
                                                  onChange={(e) =>
                                                    setlifeInsurance(
                                                      e.target.checked
                                                    )
                                                  }
                                                  type="checkbox"
                                                  data-testid="account-lifeInsurance"
                                                  className="custom-control-input"
                                                />
                                                <div className="custom-control-label">
                                                  Life
                                                </div>
                                              </label>
                                            </div>
                                          </div>
                                        </div>
                                      </Colxx>
                                      <Colxx
                                        sm={12}
                                        className="border-top pt-1"
                                      >
                                        <h5 className="benefit_types">
                                          {" "}
                                          Paid Time Off
                                        </h5>
                                      </Colxx>
                                      <Colxx sm={12}>
                                        <div className="row form-group">
                                          <div className="col-sm-4">
                                            <div className="custom-checkbox custom-control custom-control-inline">
                                              <label>
                                                <input
                                                  checked={paidHoliday}
                                                  onChange={(e) =>
                                                    setpaidHoliday(
                                                      e.target.checked
                                                    )
                                                  }
                                                  type="checkbox"
                                                  data-testid="account-paidHoliday"
                                                  className="custom-control-input"
                                                />
                                                <div className="custom-control-label row-sm-4">
                                                  Paid Holidays
                                                </div>
                                              </label>
                                            </div>
                                          </div>
                                          <div className="col-sm-4">
                                            <div className="custom-checkbox custom-control custom-control-inline">
                                              <label>
                                                <input
                                                  checked={paidSickTime}
                                                  onChange={(e) =>
                                                    setpaidSickTime(
                                                      e.target.checked
                                                    )
                                                  }
                                                  type="checkbox"
                                                  data-testid="account-paidSickTime"
                                                  className="custom-control-input"
                                                />
                                                <div className="custom-control-label">
                                                  Paid Sick Time
                                                </div>
                                              </label>
                                            </div>
                                          </div>
                                          <div className="col-sm-4">
                                            <div className="custom-checkbox custom-control custom-control-inline">
                                              <label>
                                                <input
                                                  checked={paidVacation}
                                                  onChange={(e) =>
                                                    setpaidVacation(
                                                      e.target.checked
                                                    )
                                                  }
                                                  type="checkbox"
                                                  data-testid="account-paidVacation"
                                                  className="custom-control-input"
                                                />
                                                <div className="custom-control-label">
                                                  Paid Vacation
                                                </div>
                                              </label>
                                            </div>
                                          </div>
                                          <div className="col-sm-4">
                                            <div className="custom-checkbox custom-control custom-control-inline">
                                              <label>
                                                <input
                                                  checked={flexibleHour}
                                                  onChange={(e) =>
                                                    setflexibleHour(
                                                      e.target.checked
                                                    )
                                                  }
                                                  type="checkbox"
                                                  data-testid="account-flexibleHour"
                                                  className="custom-control-input"
                                                />
                                                <div className="custom-control-label">
                                                  Flexible Hours
                                                </div>
                                              </label>
                                            </div>
                                          </div>
                                          <div className="col-sm-4">
                                            <div className="custom-checkbox custom-control custom-control-inline">
                                              <label>
                                                <input
                                                  checked={parentalLeave}
                                                  onChange={(e) =>
                                                    setparentalLeave(
                                                      e.target.checked
                                                    )
                                                  }
                                                  type="checkbox"
                                                  data-testid="account-parentalLeave"
                                                  className="custom-control-input"
                                                />
                                                <div className="custom-control-label">
                                                  Parental Leave
                                                </div>
                                              </label>
                                            </div>
                                          </div>
                                        </div>
                                      </Colxx>

                                      <Colxx
                                        sm={12}
                                        className="border-top pt-1"
                                      >
                                        <h5 className="benefit_types">
                                          Employee Savings
                                        </h5>
                                      </Colxx>
                                      <Colxx sm={12}>
                                        <div className="row form-group">
                                          <div className="col-sm-4">
                                            <div className="custom-checkbox custom-control custom-control-inline">
                                              <label>
                                                <input
                                                  checked={empDiscount}
                                                  onChange={(e) =>
                                                    setempDiscount(
                                                      e.target.checked
                                                    )
                                                  }
                                                  type="checkbox"
                                                  data-testid="account-tempDiscount"
                                                  className="custom-control-input"
                                                />
                                                <div className="custom-control-label">
                                                  Employee Discounts
                                                </div>
                                              </label>
                                            </div>
                                          </div>
                                        </div>
                                      </Colxx>
                                      <Colxx
                                        sm={12}
                                        className="border-top pt-1"
                                      >
                                        <h5 className="benefit_types">
                                          Education
                                        </h5>
                                      </Colxx>
                                      <Colxx sm={12}>
                                        <div className="row form-group">
                                          <div className="col-sm-6">
                                            <div className="custom-checkbox custom-control custom-control-inline">
                                              <label>
                                                <input
                                                  checked={profDeveAssistance}
                                                  onChange={(e) =>
                                                    setprofDeveAssistance(
                                                      e.target.checked
                                                    )
                                                  }
                                                  type="checkbox"
                                                  data-testid="account-profDeveAssistance"
                                                  className="custom-control-input"
                                                />
                                                <div className="custom-control-label">
                                                  Professional Development
                                                  Assistance
                                                </div>
                                              </label>
                                            </div>
                                          </div>
                                          <div className="col-sm-6">
                                            <div className="custom-checkbox custom-control custom-control-inline">
                                              <label>
                                                <input
                                                  checked={tuition}
                                                  onChange={(e) =>
                                                    settuition(e.target.checked)
                                                  }
                                                  type="checkbox"
                                                  data-testid="account-tuition"
                                                  className="custom-control-input"
                                                />
                                                <div className="custom-control-label">
                                                  Tuition
                                                </div>
                                              </label>
                                            </div>
                                          </div>
                                        </div>
                                      </Colxx>

                                      <Colxx
                                        sm={12}
                                        className="border-top pt-1"
                                      >
                                        <h5 className="benefit_types">
                                          Additional Benefits
                                        </h5>
                                      </Colxx>

                                      <Colxx sm={12}>
                                        <div className="row ">
                                          <div className=" col-lg-8">
                                            <Input
                                             className="t-rounded-lg"
                                              type="text"
                                              data-testid="perks"
                                              value={additionalBenefit}
                                              onChange={handleChange}
                                            />
                                            {isNullOrEmpty(additionalBenefit) &&
                                              addBenefitFlag && (
                                                <div className="t-error-color">
                                                  {benefitError}
                                                </div>
                                              )}
                                          </div>

                                          <div className=" ">
                                            <Button
                                              color="primary"
                                              outline
                                              size=""
                                              onClick={handleAdd}
                                            >
                                              Add
                                            </Button>
                                          </div>
                                        </div>
                                      </Colxx>

                                      <Colxx
                                        sm={12}
                                        className="mt-2 location-table"
                                      >
                                        <div>
                                          <Table className="table-responsive ">
                                            <thead>
                                              <tr>
                                                <th className="w-5">S.No</th>
                                                <th className="w-10">Name</th>
                                                <th className="w-5">Actions</th>
                                              </tr>
                                            </thead>
                                            {addMoreBenefitsList.length > 0 ? (
                                              addMoreBenefitsList.map(
                                                (item, index) => {
                                                  return (
                                                      <tbody key={index}>
                                                        <tr>
                                                          <td>
                                                            {getSerialNumber(
                                                              index
                                                            )}
                                                          </td>
                                                          <td>{item}</td>

                                                          <td>
                                                              <div className="actionbutton">
                                                                <>
                                                                  <i
                                                                    title="Delete Benefit"
                                                                    className="simple-icon-trash ic-profile text-dark delete-icon ml-2 emp_icon t-cursor-pointer"
                                                                    onClick={() =>
                                                                      handleRemove(
                                                                        item,
                                                                        index
                                                                      )
                                                                    }
                                                                  />
                                                                </>
                                                              </div>
                                                          </td>
                                                        </tr>
                                                      </tbody>
                                                  );
                                                }
                                              )
                                            ) : (
                                              <tfoot></tfoot>
                                            )}
                                          </Table>
                                          {addMoreBenefitsList == "" ||
                                          addMoreBenefitsList == null ? (
                                            <>
                                              {" "}
                                              <p className="nodata-text">
                                                No additional benefits available
                                              </p>
                                            </>
                                          ) : (
                                            <></>
                                          )}
                                        </div>
                                      </Colxx>
                                    </Form>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </ModalBody>
                        <ModalFooter>
                          <Button
                            test-id="uploadfile"
                            color="primary"
                            size="sm"
                            outline
                            onClick={submitBenefits}
                          >
                            Save
                          </Button>{" "}
                          <Button
                            color="primary"
                            size="sm"
                            className="ml-1"
                            outline
                            onClick={cancel}
                          >
                            Cancel
                          </Button>
                        </ModalFooter>
                      </Modal>
                      <div className="example">
                        <Table
                          className="table-responsive "
                          style={{ padding: 0 }}
                        >
                          <thead>
                            <tr>
                              <th className="w-5">S.No</th>
                              <th className="w-10">Name</th>
                              <th className="w-10">Mandated</th>
                              <th className="w-10">Compensation</th>
                              <th className="w-10">Insurance</th>
                              <th className="w-10">Paid Time Off</th>
                              <th className="w-10">Employee Savings</th>
                              <th className="w-10">Education</th>
                              <th className="w-10">Actions</th>
                            </tr>
                          </thead>
                          <tbody>
                            {accountbenefits.map((benifits, index) => {
                              return (
                                  <tr key={index}>
                                    <td>{getSerialNumber(index)}</td>

                                    <td>{benifits.name}</td>

                                    <td>
                                      <span>
                                        {(() => {
                                          if (benifits.cobra === true) {
                                            return <div>Cobra</div>;
                                          }
                                        })()}
                                      </span>
                                      <span>
                                        {(() => {
                                          if (benifits.disability === true) {
                                            return <div>Disability</div>;
                                          }
                                        })()}
                                      </span>
                                      <span>
                                        {(() => {
                                          if (benifits.medicalLeave === true) {
                                            return <div>Medical Leave</div>;
                                          }
                                        })()}
                                      </span>

                                      <span>
                                        {(() => {
                                          if (benifits.minimumWage === true) {
                                            return <div>Minimum Wage</div>;
                                          }
                                        })()}
                                      </span>
                                      <span>
                                        {(() => {
                                          if (
                                            benifits.unEmploymentBenefit ===
                                            true
                                          ) {
                                            return (
                                              <div>Unemployment Benefits</div>
                                            );
                                          }
                                        })()}
                                      </span>
                                      <span>
                                        {(() => {
                                          if (
                                            benifits.workerCompensation === true
                                          ) {
                                            return (
                                              <div>Worker Compensation</div>
                                            );
                                          }
                                        })()}
                                      </span>
                                    </td>

                                    <td>
                                      <span>
                                        {(() => {
                                          if (benifits.bonusPay === true) {
                                            return <div>Bonus Pay</div>;
                                          }
                                        })()}
                                      </span>
                                      <span>
                                        {(() => {
                                          if (
                                            benifits.compensation401k === true
                                          ) {
                                            return <div>401K</div>;
                                          }
                                        })()}
                                      </span>
                                      <span>
                                        {(() => {
                                          if (benifits.stockOption === true) {
                                            return <div>Stock Option</div>;
                                          }
                                        })()}
                                      </span>
                                    </td>

                                    <td>
                                      <span>
                                        {(() => {
                                          if (benifits.health === true) {
                                            return <div>Health</div>;
                                          }
                                        })()}
                                      </span>
                                      <span>
                                        {(() => {
                                          if (benifits.dental === true) {
                                            return <div>Dental</div>;
                                          }
                                        })()}
                                      </span>
                                      <span>
                                        {(() => {
                                          if (benifits.vision === true) {
                                            return <div>Vision</div>;
                                          }
                                        })()}
                                      </span>
                                      <span>
                                        {(() => {
                                          if (benifits.lifeInsurance === true) {
                                            return <div>Life Insurance</div>;
                                          }
                                        })()}
                                      </span>
                                    </td>

                                    <td>
                                      <span>
                                        {(() => {
                                          if (benifits.paidHoliday === true) {
                                            return <div>Paid Holidays</div>;
                                          }
                                        })()}
                                      </span>
                                      <span>
                                        {(() => {
                                          if (benifits.paidSickTime === true) {
                                            return <div>Paid SickTime</div>;
                                          }
                                        })()}
                                      </span>
                                      <span>
                                        {(() => {
                                          if (benifits.paidVacation === true) {
                                            return <div>Paid Vacation</div>;
                                          }
                                        })()}
                                      </span>
                                      <span>
                                        {(() => {
                                          if (benifits.flexibleHour === true) {
                                            return <div>Flexible Hour</div>;
                                          }
                                        })()}
                                      </span>
                                      <span>
                                        {(() => {
                                          if (benifits.parentalLeave === true) {
                                            return <div>Parental Leave</div>;
                                          }
                                        })()}
                                      </span>
                                    </td>
                                    <td>
                                      {" "}
                                      <span>
                                        {(() => {
                                          if (benifits.empDiscount === true) {
                                            return <div>Employee Discount</div>;
                                          }
                                        })()}
                                      </span>
                                    </td>
                                    <td>
                                      {" "}
                                      <span>
                                        {(() => {
                                          if (
                                            benifits.profDeveAssistance === true
                                          ) {
                                            return (
                                              <div>Prof. Dev. Assistance</div>
                                            );
                                          }
                                        })()}
                                      </span>
                                      <span>
                                        {(() => {
                                          if (benifits.tuition === true) {
                                            return <div>Tuition</div>;
                                          }
                                        })()}
                                      </span>
                                    </td>
                                    <td>
                                      <div className="actionbutton">
                                        <i
                                          className="simple-icon-note edit-copyiconsize arrow-icon-color mr-2 emp_icon t-cursor-pointer"
                                          onClick={() => {
                                            openModel(benifits);
                                          }}
                                          title="Edit Benefit"
                                        />

                                        <i
                                          className="simple-icon-trash ic-profile  text-dark delete-icon ml-2 emp_icon t-cursor-pointer"
                                          title="Delete Benefit"
                                          onClick={() => {
                                            handledeleteaccountbenefit(
                                              benifits.id,
                                              benifits.name
                                            );
                                          }}
                                        />
                                      </div>
                                    </td>
                                  </tr>
                              );
                            })}
                          </tbody>
                        </Table>

                        {accountbenefits == "" || accountbenefits == null ? (
                          <>
                            <p className="nodata-text">
                              No account Benefits available
                            </p>
                          </>
                        ) : (
                          <></>
                        )}
                      </div>
                    </Colxx>
                  </Row>
                }
              </div>
            </CardBody>

            <CardFooter>
              <Row className="wrapper">
                <h3 className="ml-3 matrecords">
                  {" "}
                  Total matching records : {size}
                </h3>

                <Pagination
                  currentPage={currentPage}
                  totalPage={totalPage}
                  numberLimit={5}
                  firstIsActive={true}
                  onChangePage={(e) => onChangePage(e)}
                />
              </Row>
            </CardFooter>
          </Card>
        </Colxx>
      </Row>

      <Modal isOpen={Boolean(modalDelete)} toggle={() => setModalDelete(!modalDelete)}>
        <ModalBody>
          Do you want to delete benefits
          <strong> {accountbenefitname}</strong>?
        </ModalBody>
        <ModalFooter className="p-3">
          {" "}
          <Button
            color="primary"
            size="sm"
            outline
            onClick={() => setModalDelete(false)}
          >
            Cancel
          </Button>
          <Button
            color="primary"
            size="sm"
            outline
            onClick={(e) => {
              deletebenefits();
            }}
          >
            Delete
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default AccountBenefits;
